import { Input, Button, Space } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import _ from 'lodash';

export const UpdateTableConfig = (handleSearch, handleReset) => {
  const getColumnSearchProps = (dataIndex) => {
    return {
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
            style={{ width: 188, marginBottom: 8, display: 'block' }}
          />
          <Space>
            <Button
              type="primary"
              onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
              icon={<SearchOutlined />}
              size="small"
              style={{
                width: 90,
                backgroundColor: '#32d193',
                borderColor: '#32d193',
                color: 'white',
              }}
            >
              Search
            </Button>
            <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
              Reset
            </Button>
          </Space>
        </div>
      ),
      filterIcon: (filtered) => (
        <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
      ),
    };
  };
  return [
    {
      title: 'Order ID',
      dataIndex: 'order_id',
      key: 'order_id',
      width: '3%',
    },
    {
      title: 'Previous Product',
      dataIndex: 'previousproduct',
      key: 'previousproduct',
      width: '3%',
    },
    {
      title: 'New Product',
      dataIndex: 'currproduct',
      key: 'currproduct',
      width: '3%',
    },
    {
      title: 'Old Price',
      dataIndex: 'total_price',
      key: 'total_price',
      width: '3%',
    },
    {
      title: 'Credit',
      dataIndex: 'oldprice',
      key: 'oldprice',
      width: '3%',
    },
    {
      title: 'Subscribtion',
      dataIndex: 'subscription_period',
      key: 'subscription_period',
      width: '3%',
      render: (subscription_period) => <>{subscription_period} months</>
    },

    {
      title: 'Updated Date',
      dataIndex: 'updated_at',
      key: 'updated_at',
      width: '3%',
      render: (updated_at) => {
        return <div>{updated_at ? updated_at.split('T')[0] : 'N/A'}</div>;
      },
    },


  ];
};
